export default "__VITE_ASSET__DnNYsESG__"